import { useImageLightboxState } from '@application/state';
import { ImageLightbox } from '@presentation/components';
import type { FC } from 'react';
import { useEffect } from 'react';

export const LoadingOverlayController: FC = () => {
  const { isOpen, index, images, setIndex, close } = useImageLightboxState();

  useEffect(() => {
    const handleEsc = (event: { keyCode: number }) => {
      if (isOpen && event.keyCode === 27) {
        close();
      }
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('keydown', handleEsc);
      return () => {
        window.removeEventListener('keydown', handleEsc);
      };
    }
  }, [close, isOpen]);

  return !isOpen ? null : (
    <ImageLightbox
      images={images}
      index={index}
      onClose={close}
      onPrevious={() => setIndex('previous')}
      onNext={() => setIndex('next')}
      onThumbnailClick={(thumbnailIndex) => setIndex(thumbnailIndex)}
    />
  );
};
